import React, { useContext } from 'react';
import styled from 'styled-components';
import { AppContext } from '@prisjakt/ui-app-context';
import { layout, media } from '@prisjakt/ui-base';
import { H3Text } from '@prisjakt/ui/text/variants';
import T from '@prisjakt/ui-translate';

type Props = {
  name?: string;
  showImage?: boolean;
};

export const NoReviews = (props: Props) => {
  const { market, t } = useContext(AppContext);

  return (
    <FirstToReviewText>
      {props.showImage && (
        <Image
          alt=""
          src={`${market.cdn}/g/rfe/illustrations/no-reviews-illustration.png`}
        />
      )}
      <H3Text>{t('reviews', 'info.no-reviews')}</H3Text>
      {props.name && (
        <T domain="reviews" name={props.name}>
          info.first-review.md
        </T>
      )}
    </FirstToReviewText>
  );
};

const FirstToReviewText = styled.div`
  color: ${p => p.theme.text.primary};
  text-align: center;

  p {
    margin: 0;
  }

  ${media.mediumDown`
    margin-top: ${layout.measurements.spacing100};
  `}
`;

const Image = styled.img`
  margin-bottom: ${layout.measurements.spacing050};
  max-width: 310px;
`;
